import { ApiContext } from '../../types'
import { AuthHelper } from '@/api_client'
import { deserializeCreditUsage } from '@/api_client/api/serializers/credit_usage'
import { deserializeCreditRecord } from '@/api_client/api/serializers/credit_record'

export default async function getCreditRecords(
  { client, config }: ApiContext,
  params = {},
) {
  const response = await client.creditRecords.list(
    AuthHelper.getAccessToken(),
    params,
  )
  if (response.isSuccess()) {
    const success = response.success()
    const data = success.data
    const meta = success.meta
    console.log(data)
    // num_pages:1
    // per_page:20
    // total_count:0
    return {
      data: data.map((item: any) => deserializeCreditRecord(item)),
      meta: meta,
    }
  } else {
    console.log('getUsers: fail')
    throw response.fail()
  }
}
